// extracted by mini-css-extract-plugin
export default {"root":"InvestorDetailsSummaryCard_root__8UdLU","content":"InvestorDetailsSummaryCard_content__ePnwc","addresses":"InvestorDetailsSummaryCard_addresses__8J4v8"};